import styled from 'styled-components';

export const ReactionsWrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  margin: 8px 0;
  padding-bottom: 7px;
  &.response-reactions {
    justify-content: flex-end;
    padding: 8px 55px 0;
    .reaction-type {
      ion-chip {
        height: 34px;
        width: 64px;
        padding: 0 15px 0 12px;
      }
      .emoji {
        font-size: 15px !important;
        margin-right: 11px;
      }
      ion-label {
        font-size: 0.9rem;
      }
      &.selected {
        ion-label {
          font-weight: 700;
        }
      }
    }
  }
  ion-icon {
    font-size: 19px;
    margin-right: 5px;
    opacity: 0.8;
  }
  .emoji {
    font-size: 12px;
    margin-right: 10px;
    position: relative;
    top: 1px;
  }
  ion-chip {
    font-size: 0.8rem;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-color: rgba(var(--ion-color-base-rgb), 0.2);
    background: rgba(var(--ion-color-dark-rgb), 0);
    border-radius: 50px;
    padding: 0 12px 0 7px;
    margin: 0 8px 0 0;
    transition: 0.2s;
    &:hover {
      border-color: rgba(var(--ion-color-base-rgb), 0.5);
    }
  }
  ion-badge {
    position: absolute;
    bottom: -12px;
    right: 0;
    font-size: 0.7rem;
  }
  .reaction-type {
    position: relative;
    margin-right: 6px;
    ion-label {
      color: rgba(var(--ion-color-base-rgb), 1);
    }

    &.selected {
      opacity: 1;
      ion-label {
        color: rgba(var(--ion-color-base-rgb), 1);
      }
      ion-chip {
        border-color: rgba(var(--ion-color-base-rgb), 0.7);
        background: rgba(var(--ion-color-base-rgb), 0.1);
      }
      ion-icon {
        opacity: 1;
      }
    }
  }
`;
